import styled from 'styled-components'

export const TokenDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 8px 0 0;
  width: 50%;
`

export const TokenDetailsTitle = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.C};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const TokenDetailsValue = styled.span`
  word-wrap: break-word;
`
